import { useEffect } from 'react';
import { checkAndHandleCallback } from 'utils/callbackHandler';

/**
 * Component that handles callback URL redirects
 * This should be included in the main App component or key route components
 * to check for callback URLs when the user returns from external services (like Stripe)
 */
const CallbackHandler = () => {
  useEffect(() => {
    // Check for callback URL on component mount
    const wasRedirected = checkAndHandleCallback();
    
    if (wasRedirected) {
      console.log('CallbackHandler: Performed callback redirect');
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default CallbackHandler;
